import { render, staticRenderFns } from "./LuckWorld.vue?vue&type=template&id=492e2710&scoped=true&"
import script from "./LuckWorld.vue?vue&type=script&lang=js&"
export * from "./LuckWorld.vue?vue&type=script&lang=js&"
import style0 from "./LuckWorld.vue?vue&type=style&index=0&id=492e2710&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "492e2710",
  null
  
)

export default component.exports